import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-10 w-full rounded-lg px-3 py-2 text-sm",
        "bg-surface dark:bg-surface-2 text-text",
        "border border-border placeholder:text-text-subtle",
        "transition-[border-color,box-shadow] duration-150",
        "hover:border-border-strong",
        "focus-visible:outline-none focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-ring/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
